export const IMPORT_METHODS: Array<{
  name: string;
  value: string;
}> = [
  {
    name: 'Client List',
    value: 'client_list',
  },
  {
    name: 'Staff List',
    value: 'staff_list',
  },
  {
    name: 'Zipped Organizer/Backup Files for Rollover Items',
    value: 'zipped_rollover_items',
  },
  {
    name: 'Other Document',
    value: 'other_document',
  },
  {
    name: 'Rollover Items Import',
    value: 'rollover_items_import',
  },
] as const;

export const CLIENT_LIST_TYPES: Array<{
  name: string;
  value: string;
}> = [
  {
    name: 'Select Client List Type',
    value: '',
  },
  {
    name: 'Individuals (1040) List',
    value: 'individuals',
  },
  {
    name: 'Entities (1120, 1065, 1041, etc) List',
    value: 'entities',
  },
] as const;
